import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ScreenPickerProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { configurationAlreadyExistsKey } from 'app/area/indicator-factors/constants';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export type SeverityProps = ScreenPickerProps & {
  severityLabel: (translation: CodetableTranslation) => string;
  isSeverityRequired?: boolean;
};

export const Severity = (props: SeverityProps) => {

  const { codeItem, updateByKey, resetValidation, codetableOptions, loadCodetableOptions, translation, validation, readOnlyConfig,
    severityLabel, breadcrumbs, isSeverityRequired } = props;

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(ScreenPicker.severity);
    if (validation.category && validation[configurationAlreadyExistsKey]) {
      resetValidation(ScreenPicker.category);
      resetValidation(configurationAlreadyExistsKey);
    }
    updateByKey(ScreenPicker.severity, value);
  };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableOptionsIds.severity, loadOptionsParams);
  };

  const codeOptions = (!!codetableOptions.severity && codetableOptions.severity.codes || []) as CodeComplexValue<number>[];

  const severityValidation = !!validation && !!validation.severity ? validation.severity : undefined;

  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  const codetableId = codetableOptionsIds[ScreenPicker.severity];

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs);

  const required = isSeverityRequired ?? !readOnly;

  return <CodeSinglePicker
    id={ScreenPicker.severity}
    label={severityLabel?.(translation) ?? translation.severity}
    valueItem={codeItem && codeItem.severity}
    searchRequired={false}
    required={required}
    readOnly={readOnly}
    options={codeOptions}
    fetchingOptions={codetableOptions.severity && codetableOptions.severity.fetching}
    extraFooterButton={extraFooterButton}
    translation={translation}

    onLoadOptions={onLoadOptions}
    onChange={onChange}
    validation={severityValidation}
  />;
};
